export default "__VITE_ASSET__3beecd14__"